// extracted by mini-css-extract-plugin
export default {"chip":"StatusChip_chip__LT8v6","active":"StatusChip_active__B5JNN","pending":"StatusChip_pending__CE-LE","disabled":"StatusChip_disabled__Lu3aG"};